import LocalDatabase from "./local-database";

class DatabaseStore {
    private _db: LocalDatabase;

    constructor(databaseName: string, version: number, private _storeName: string) {
        this._db = new LocalDatabase(databaseName, version);
    }

    get(callback: any) {
        this._db.get(this._storeName, callback);
    }

    clear() {
        this._db.clear(this._storeName);
    }

    add(item: any) {
        this._db.add(this._storeName, item);
    }
}

export default DatabaseStore;
